define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var ProductCategoryModel = /** @class */ (function () {
        function ProductCategoryModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.ParentId = ko.observable();
            this.ParentName = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, ProductCategoryModel.Mapping, self);
            }
        }
        ProductCategoryModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new ProductCategoryModel(options.data);
            }
        };
        return ProductCategoryModel;
    }());
    return ProductCategoryModel;
});
//# sourceMappingURL=ProductCategoryModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/ProductCategoryModel.js
// module id = 291
// module chunks = 2